export default "__VITE_ASSET__BAYjqTCl__"